import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import LoginForm from '../forms/LoginForm'
import CustomLink from '../components/CustomLink'
import AuthLayout from './AuthLayout'
import BetaTesting from './BetaTesting'
import Button from '../elements/Button'

class Login extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            showUsernameCopy: false
        }

        this.timer = null
    }

    componentDidMount () {
	    this.redirectIfLoggedIn()
    }

    componentDidUpdate (prevProps, prevState, snapshot) {
	    if (prevProps.isLoggedIn !== this.props.isLoggedIn && this.props.isLoggedIn) {
	        this.timer = setTimeout(this.redirectIfLoggedIn.bind(this), 500)
        }
    }

    componentWillUnmount () {
	    if (this.timer) {
            clearTimeout(this.timer)
        }
    }

    redirectIfLoggedIn () {
        if (this.props.isLoggedIn) {
            this.props.history.push('/dashboard')
        }
    }

    render () {
        const UsernameCopy = (
            <div className='font-small px-5 px-lg-0'>
                <p className='bold'>Forgotten your username?</p>
                <p>Your username will most likely be your email address / phone number or a username you have created in the past.</p>
                <p>If you still can't login then please give us a call on <a href='tel: 133938'>13 39 38</a>.</p>
            </div>
        )

        return (
            <AuthLayout
                title='Hello'
                subTitle='Login to My Exetel'
                className='login-page'
                backLinkLocation='exetel'
            >
                <LoginForm />
                <div className="font-small px-5 px-lg-0 mt-4">
                    <p>When you login to the MyExetel Members area you will be prompted to provide a one-time verification code in addition to login details.</p>
                    <p>This is a process called Multi-Factor Authentication (MFA), which has been introduced to strengthen the security of your account.</p>
                    <p>
                        <CustomLink to='https://s3.ap-southeast-2.amazonaws.com/files.exetel.com.au/security/MyExetel-MFA-How-To-Guide.pdf'><span className='bold'>More information</span></CustomLink>
                    </p>
                </div>
                <p className='mt-4 mb-2'>
                    <small>Forgotten your <CustomLink to='/forgot-username'><span className='bold'>username</span></CustomLink> or <CustomLink to='/forgot-password'><span className='bold'>password</span></CustomLink>?</small>
                </p>
                {this.state.showUsernameCopy ? UsernameCopy : ''}
                <p className='mt-0 mb-2'>
                    <small>Business customer? <a href='https://business.exetel.com.au/login' className='bold'>Login here</a>.</small>
                </p>
                <div className='external-btns'>
                    <Button title='Webmail' href='https://webmail.exetel.com.au/' className='mr-2' />
                    <Button title='Forums' href='https://forum.exetel.com.au/' />
                </div>

                <BetaTesting />
            </AuthLayout>
        )
    }
}

const mapStateToProps = state => ({
    isLoggedIn: state.auth.isLoggedIn,
    redirectTo: state.auth.redirectTo
})

export default connect(mapStateToProps)(withRouter(Login))



// WEBPACK FOOTER //
// ./resources/js/auth/Login.js